<template>
  <!-- TABLE -->
  <v-client-table
    :data="data"
    :columns="columns"
    :options="options"
  >
    <template v-slot:name="{ row }">
      <span class="link-class" @click="goToFile(row)">
        <i class="fas fa-level-up-alt rotate-90 ml-4 mr-2" />
        {{ row.name }}
      </span>
    </template>

    <!-- STATS COLUMN -->
    <template v-slot:stats="{ row }">
      <!-- Row errors -->
      <div v-if="row.stats && row.stats.landing_db_ingestion">
        <div
          v-for="item in ['total_count','ingested_count','error_count']"
          :key="item"
          class="table-sub-class text-sm inline"
        >
          <div class="mb-1">
            {{ getStatsDisplay(item) | capitalize }}: {{ row.stats.landing_db_ingestion | get([item], '') }}
            <span class="clickable color-blue">
              <i
                v-if="item == 'error_count' && row.stats.landing_db_ingestion.error_count > 0"
                class="fas fa-plus-circle"
                @click="$emit('showErrors', row)"
              />
            </span>
          </div>
        </div>
      </div>
    </template>

    <!--MATCHING STATS COLUMN -->
    <template v-slot:matchingStats="{ row }">
      <div v-if="row.stats && row.stats.matching">
        <div
          v-for="(v, k) in row.stats.matching"
          :key="k"
          class="table-sub-class text-sm inline"
          style="opacity:0.8;"
        >
          <div>{{ getStatsDisplay(k) | capitalize }}: {{ v }}</div>
        </div>
        <div class="table-sub-class text-sm inline">
          {{ $t('matched') | capitalize }}: {{ row.last_matching_date | transformDate("MMMM Do YYYY") }}
        </div>
      </div>
    </template>

    <!--  DATE COLUMN -->
    <template v-slot:period="{ row }">
      <div
        v-if="row.start_date || row.end_date"
        class="date-column"
      >
        <div v-if="row.start_date">
          <div class="table-main-class">
            {{ row.start_date | transformDate("MMMM Do YYYY") }}
          </div>
          <div class="table-sub-class text-sm">
            {{ row.start_date | transformDate("h:mm a") }}
          </div>
        </div>
        <div v-else class="date-separator">?</div>
        <span class="date-separator">-</span>
        <div v-if="row.end_date">
          <div class="table-main-class">
            {{ row.end_date | transformDate("MMMM Do YYYY") }}
          </div>
          <div v-if="row.end_date" class="table-sub-class text-sm">
            {{ row.end_date | transformDate("h:mm a") }}
          </div>
        </div>
        <div v-else class="date-separator">?</div>
      </div>
    </template>

    <!-- STATUS COLUMN-->
    <template v-slot:status="{ row }">
      <Status
        v-if="row.status == statusTypes.PENDING"
        :text="$t('pending') | capitalize"
        :icon="['fas', 'question-circle']"
        color="orange"
      />
      <Status
        v-if="row.status == statusTypes.PROCESSING"
        :text="$t('processing') | capitalize"
        :icon="['fas', 'question-circle']"
        color="orange"
      />
      <Status
        v-if="row.status == statusTypes.LANDED"
        :text="$t('landed') | capitalize"
        :icon="['fas', 'check-circle']"
        color="green"
      />
      <Status
        v-if="row.status == statusTypes.INGESTED"
        :text="$t('ingested') | capitalize"
        :icon="['fas', 'check-circle']"
        color="green"
      />
      <Status
        v-if="row.status == statusTypes.MATCHED"
        :text="$t('matched') | capitalize"
        :icon="['fas', 'check-circle']"
        color="green"
      />
      <Status
        v-if="row.status == statusTypes.ERROR"
        :text="$t('error') | capitalize"
        :icon="['fas', 'exclamation-circle']"
        color="red"
        :active="true"
        @click="$emit('showErrors', row, true)"
        clickable
      />
    </template>
  </v-client-table>
</template>

<style lang="scss" scoped>
  ::v-deep thead { display: none !important; }
</style>

<script>
import { get } from "lodash"
import { mapGetters } from "vuex"

export default {
  name: "PlayListFileSheetTable",
  props: {
    data: {
      type: Array
    }
  },

  data () {
    return {
      columns: [
        "name",
        "upload_date",
        "period",
        "usage_type",
        "status",
        "stats",
        "matchingStats",
        "readyForDistribution",
        "actions"
      ],
      options: {
        skin: "table table-striped",
        filterable: false,
        columnsClasses: {
          name: "width-large",
          upload_date: "width-medium",
          period: "width-medium",
          usage_type: "width-small",
          uploader: "width-medium",
          status: "width-small",
          stats: "width-medium",
          matchingStats: "width-medium",
          readyForDistribution: "width-small",
        },
      }
    }
  },
  computed: {
    ...mapGetters("soundsys", ["statusTypes"]),
  },
  methods: {
    goToFile (row) {
      this.$router.push({
        name: "usages",
        query: {
          source: row.id
        }
      })
    },
    getStatsDisplay (key) {
      const mapToDisplay = {
        automatched: this.$t("automatched"),
        auto_manually_matched: this.$t("auto_manually_matched"),
        auto_manually_matched_count: this.$t("auto_manually_matched"),
        automatched_count: this.$t("automatched"),
        error: this.$t("error"),
        error_count: this.$t("errors"),
        ingested_count: this.$t("ingested"),
        landed: this.$t("landed"),
        manually_matched: this.$t("manually_matched"),
        manually_matched_count: this.$t("manually_matched"),
        matched: this.$t("matched"),
        total_count: this.$t("total"),
        unmatched: this.$t("unmatched"),
        unmatched_no_duplicates: this.$t("unmatched_no_duplicates"),
        unmatched_count: this.$t("unmatched"),
      }
      return get(mapToDisplay, key, key)
    }
  }
}
</script>
